/**
 * Detects if an error is due to a failed chunk/module fetch.
 */
export function isChunkLoadError(error) {
  if (!error) return false;
  const message = error.message || String(error);
  const lowerMessage = message.toLowerCase();

  return (
    lowerMessage.includes("failed to fetch dynamically imported module") ||
    lowerMessage.includes("failed to load module script") ||
    lowerMessage.includes("error loading dynamically imported module") ||
    lowerMessage.includes("importing a module script failed") ||
    (lowerMessage.includes("failed to fetch") && (lowerMessage.includes("chunk") || lowerMessage.includes("assets/"))) ||
    lowerMessage.includes("loading chunk")
  );
}

/**
 * Handles chunk load errors by reloading the page once within a cooldown window.
 * Returns true if a reload was triggered, false otherwise.
 */
export function handleChunkLoadError(error) {
  if (isChunkLoadError(error)) {
    const lastReloadKey = "last-chunk-error-reload";
    const now = Date.now();
    const lastReload = sessionStorage.getItem(lastReloadKey);

    // Only reload if we haven't reloaded due to a chunk error in the last 15 seconds
    if (!lastReload || now - parseInt(lastReload, 10) > 15000) {
      sessionStorage.setItem(lastReloadKey, now.toString());
      console.warn("Chunk loading error detected. Reloading page to fetch latest version...");
      try {
        const url = new URL(window.location.href);
        url.searchParams.set("t", now.toString());
        window.location.replace(url.toString());
      } catch (e) {
        console.error("Failed to parse URL for cache-busting reload, falling back to basic reload", e);
        window.location.reload();
      }
      return true;
    }
  }
  return false;
}
